import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import Modals from '../Modals';
import { useAppContext } from 'components/Context/AppContext';
import { Button } from 'components/Global';
import { trackEvent } from 'utils/analytics';
import { ReactComponent as Xsign } from 'icons/x-sign-icon.svg';

const ConfirmationVehiclePriceModal = () => {
  const { showVehiclePriceConfirmation, setShowVehiclePriceConfirmation } = useAppContext();

  const isVehicleUpdateByLocation = useFliptBoolean('FLAG_FE_VEHICLE_UPDATE_BY_LOCATION', false, 'anonymous');

  const continueHandler = () => {
    trackEvent('price_scope_decided', {
      scope: 'bulk',
    });
    showVehiclePriceConfirmation?.onConfirm?.();
    setShowVehiclePriceConfirmation({
      show: false,
      onConfirm: () => {},
      vehicleName: '',
      ...(isVehicleUpdateByLocation && { locationName: '', onReject: () => {} }),
    });
  };

  const closeHandler = () => {
    trackEvent('price_scope_decided', {
      scope: 'dismissed',
    });
    setShowVehiclePriceConfirmation({
      show: false,
      onConfirm: () => {},
      vehicleName: '',
      ...(isVehicleUpdateByLocation && { locationName: '', onReject: () => {} }),
    });
  };

  const rejectHandler = () => {
    trackEvent('price_scope_decided', {
      scope: 'single',
    });
    showVehiclePriceConfirmation?.onReject?.();
    setShowVehiclePriceConfirmation({
      show: false,
      onConfirm: () => {},
      vehicleName: '',
      ...(isVehicleUpdateByLocation && { locationName: '', onReject: () => {} }),
    });
  };

  const getConfirmationText = () => {
    if (isVehicleUpdateByLocation) {
      return (
        <p className="vehicle-price-confirmation-sub">
          Apakah harga ini berlaku untuk semua{' '}
          <span style={{ fontWeight: 'bold' }}>{showVehiclePriceConfirmation.vehicleName}</span> di{' '}
          <span style={{ fontWeight: 'bold' }}>{showVehiclePriceConfirmation.locationName}</span> ?
        </p>
      );
    }

    return (
      <p className="vehicle-price-confirmation-sub">
        Apakah Anda ingin menerapkan harga baru ini ke seluruh data{' '}
        <span style={{ fontWeight: 'bold' }}>{showVehiclePriceConfirmation.vehicleName}</span> ?
      </p>
    );
  };

  const getConfirmationButton = () => {
    if (isVehicleUpdateByLocation) {
      return (
        <>
          <Button wfull size="md" className="button" onClick={rejectHandler} variant="outline">
            Tidak
          </Button>
          <Button wfull size="md" className="button" onClick={continueHandler} variant="primary">
            Iya
          </Button>
        </>
      );
    }

    return (
      <Button wfull size="md" className="button" onClick={continueHandler}>
        Iya, Lanjutkan
      </Button>
    );
  };

  return (
    <Modals setState={closeHandler}>
      <div
        className="vehicle-price-confirmation-modal"
        style={isVehicleUpdateByLocation ? { width: '650px', textAlign: 'center' } : { width: '500px' }}
      >
        <Xsign className="vehicle-price-confirmation-close-button" onClick={closeHandler} />
        <h3 className="vehicle-price-confirmation-title">Peringatan perubahan harga</h3>
        {getConfirmationText()}
        <div className="vehicle-price-confirmation-buttons">{getConfirmationButton()}</div>
      </div>
    </Modals>
  );
};

export default ConfirmationVehiclePriceModal;
